import DataUpdate from './DataUpdate';

export default DataUpdate; 